import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueLocalStorage from 'vue-localstorage'
import Vuebar from 'vuebar';
import BootstrapVue from 'bootstrap-vue'
import { TooltipPlugin } from 'bootstrap-vue'
import VueNotification from 'vue-notification'
import VueModal from 'vue-js-modal'
import App from './App.vue'

import './../Libs/Broadcast'
import './../Libs/Broadcast.Dom'

import './directives/pseudo-modal'

import { Server } 			from './services/Server'
import { Metadata } 		from './services/Metadata'
import { User } 			from './services/User'
import { Template } 		from './services/Template'
import { Project } 			from './services/Project'
import { Section } 			from './services/Section'
import { Settings } 		from './services/Settings'
import { Asset } 			from './services/Asset'
import { Localization } 	from './services/Localization'
import { Layout } 			from './services/Layout'
import { Notifications } 	from './services/Notifications'
import { Monitoring } 		from './services/Monitoring'

Vue.use(Vuebar);
Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(TooltipPlugin);
Vue.use(VueLocalStorage, {name: 'ls', bind: true});
Vue.use(VueNotification, {name: 'notify', componentName: 'VueNotification'});
Vue.use(VueModal, {componentName: 'VueModal'});

Vue.config.productionTip = false;

const i18n = new VueI18n({
	locale: 'en',
	fallbackLocale: 'en',
	messages: {},
});

const app = new Vue({
	i18n,
	render: h => h(App),
	//router,
	//template: '<App/>',
	/*components: {
		App
	}*/
}).$mount('#vue-mount-point');

Server.init();
Metadata.init();
User.init();
Template.init();
Project.init();
Section.init();
Settings.init();
Asset.init();
Localization.init();
Layout.init();
Notifications.init();
Monitoring.init();

Server.connect();

//SettingsConfigurator.load();

//window.App.Vue = app;
//window.App.VueI18n = i18n;


